import React, {ComponentProps} from 'react';
import {gql} from '@apollo/client';
import {IntercomProvider} from 'react-use-intercom';
import {useEnvironment} from './Environment';
import {Intercom as Identity} from '../__generated__/Intercom';
import isNil from '../util/isNil';

export const intercomFragment = gql`
  fragment Intercom on Identity {
    id
    catererAccount {
      id
      intercomToken
    }
  }
`;

interface Props extends Omit<ComponentProps<typeof IntercomProvider>, 'appId'> {
  me?: Identity;
}

const Intercom = ({me, ...props}: Props) => {
  const environment = useEnvironment();
  return (
    <IntercomProvider
      {...props}
      autoBoot
      shouldInitialize={!isNil(me?.catererAccount)}
      appId={environment.intercomAppId as string}
      autoBootProps={
        me?.catererAccount?.intercomToken
          ? {
              intercomUserJwt: me?.catererAccount?.intercomToken,
            }
          : undefined
      }
    />
  );
};

export default Intercom;
